import { useNavigate } from '@integrations/routing'
import { OnboardingActions, paths, useOnboardingActionQry } from 'mmfintech-backend-api'

export function useOnboardingAction() {
  const navigate = useNavigate()
  const { onboardingAction } = useOnboardingActionQry()

  function startOrContinueOnboarding() {
    switch (onboardingAction) {
      case OnboardingActions.NOT_STARTED:
      case OnboardingActions.ONBOARDING:
        navigate(paths.onboarding.continueOnboarding())
        break

      case OnboardingActions.DOCUMENTS:
        // todo navigate(paths.onboarding.documents())
        break

      case OnboardingActions.QUESTIONNAIRE:
        navigate(paths.onboarding.questionnaireKyb())
        break

      case OnboardingActions.APPLICATION_FEE:
        // todo
        break

      default:
        // case 'UNDER_REVIEW':
        // case 'NONE':
        navigate(paths.dashboard())
    }
  }

  return {
    onboardingAction,
    startOrContinueOnboarding
  }
}
